import { saveObjectVT_DB, DB_CFG_VISITA, saveArrayVT_DB, getDataVT_DB, DB_PROD_VISITA, DB_VISITAS, createVT_DB, deleteByKeyVT_DB, updateVT_DB, DB_SYNC, DB_DOCS, getDataByKeyVT_DB } from "@/db/visita_tecnica_db";
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import store from ".";
import { saveAtalhosIniciais } from "@/db/sistema";
import { base64ToBlobUrl, isMobileMq, toBase64 } from "@/global";

function defaultVisita() {
  return {
    id: 0,
    data_visita: moment().format("YYYY-MM-DD"),
    matricula: 0,
    nome_produtor: 0,
    nro_vacas_ordenha: 0,
    qtd_ordenhas: 0,
    nro_vacas_secas: 0,
    nro_novilhas: 0,
    nro_bezerras: 0,
    pre_parto: false,
    obs_pre_parto: "",
    producao_media: 0.0,
    ecc: 0.0,
    dias_lactacao: 0,
    gordura_leite: 0.0,
    proteina_leite: 0.0,
    lactose: 0.0,
    css: 0.0,
    nul: 0.0,
    temperatura_ambiente: 0.0,
    umidade_ar: 0.0,
    obs_ventiladores: "",
    obs_cochos: "",
    qtd_tratos: 0,
    tmr: false,
    obs_tmr: "",
    obs_silagem: "",
    obs_penn_state: "",
    obs_cascos: "",
    obs_fezes: "",
    obs_gerais: "",
    docs: [],
    peneiras: [],
    lotes: [],
    atualizar: false
  }
}

const getDefaultState = () => {
  return {
    visitas: {
      carregando: true,
      atualizandoDB: false,
      itens: [],
    },
    produtores: {
      carregando: false,
      pesquisa: "",
      modo: "",
      msgSync: "",
      lista: []
    },
    configuracoes: {
      carregando: false,
      dados: null
    },
    removendoVisita: false,
    id_visita: 0,
    id_sync: 0,
    visita: defaultVisita(),
    gerandoRelat: false,
    sincronizando: false,
    atualizandoVisita: false,
    filtros: {
      dtini: "",
      dtfim: "",
    },
    output_doc: "url"
  };
};

const visitaTecnicaStore = {
  namespaced: true,
  state: {
    ...getDefaultState(),
  },
  mutations: {
    resetVisita(state) {
      state.visita = defaultVisita()
    },
  },
  actions: {
    async buscarConfiguracoes(context) {

      context.state.configuracoes.carregando = true
      context.state.configuracoes.dados = null
      if (navigator.onLine) {
        await axios.get("/nutricao-animal/visita-tecnica/configuracoes")
          .then((res) => {
            if (res.data.success) {
              context.state.configuracoes.dados = res.data.data
              context.state.configuracoes.carregando = false
            } else {
              Vue.toasted.error(res.data.msg, { position: "bottom-center" })
            }
          })
          .catch((e) => {
            Vue.toasted.error(e, { position: "bottom-center" })
          })
      } else {
        var cfg_offline_db = await getDataVT_DB(DB_CFG_VISITA)
        if (cfg_offline_db.length > 0)
          context.state.configuracoes.dados = cfg_offline_db[0]
        context.state.configuracoes.carregando = false
      }
    },
    async buscarProdutores(context) {

      context.state.produtores.carregando = true
      context.state.produtores.lista = []
      if (navigator.onLine) {
        await axios.get("/nutricao-animal/visita-tecnica/produtores", {
          params: {
            pesquisa: context.state.produtores.pesquisa,
            modo: context.state.produtores.modo
          }
        })
          .then((res) => {
            if (res.data.success) {
              context.state.produtores.lista = res.data.data
            } else {
              Vue.toasted.error(res.data.msg)
            }
          })
          .catch((e) => {
            Vue.toasted.error(e)
          })
      } else {
        var produtoresOff_DB = await getDataVT_DB(DB_PROD_VISITA)
        context.state.produtores.lista = produtoresOff_DB.filter((p) => p.nome.toLowerCase().includes(context.state.produtores.pesquisa.toLowerCase()) || p.matr == context.state.produtores.pesquisa)
      }

      context.state.produtores.carregando = false

    },

    async atualizarVisitasCacheOffline(context) {
      if (navigator.onLine && isMobileMq()) {
        var res = await axios.get("/nutricao-animal/visita-tecnica/visitas", {
          params: {
            id: context.state.id_sync,
            dtini: context.state.configuracoes.dados.data_ini_sync,
            dtfim: context.state.configuracoes.dados.data_fim_sync,
          }
        })

        if (res.status == 200 && res.data.success) {
          var visitasOn = res.data.data
          for (const key in visitasOn) {
            context.state.visita = visitasOn[key]
            if (context.state.id_sync > 0)
              await updateVT_DB(DB_VISITAS, context.state.visita.id, context.state.visita)
          }

          if (context.state.id_sync == 0) {
            context.state.visita = defaultVisita()
            await saveArrayVT_DB(DB_VISITAS, visitasOn)
          }
        }
      }
    },

    async atualizarImagensCacheOffline(context) {

      if (navigator.onLine && isMobileMq()) {

        var visitasDB = await getDataVT_DB(DB_VISITAS)
        var arrDocs = []

        for (const vis of visitasDB) {
          context.state.visita = vis
          for (const d of context.state.visita.docs) {
            context.state.output_doc = "file-sync"
            await context.dispatch("buscarDocumento", d.id)
            arrDocs.push({ ...d, id_visita: vis.id, remover: false })
          }
        }
        context.state.visita = defaultVisita()
        context.state.output_doc = "url"

        await saveArrayVT_DB(DB_DOCS, arrDocs)

      }

    },

    async buscarDocsVisitaDB(context, param) {

      var docsVisita = await getDataByKeyVT_DB(DB_DOCS, param.id)

      var pos = -1
      if (docsVisita) {
        if (param.id > 0)
          pos = context.state.visita.docs.findIndex((d) => d.id == param.id)
        else if (param.thumb_url != '')
          pos = context.state.visita.docs.findIndex((d) => d.thumb_url == param.doc_url)
      }

      if (pos >= 0) {
        const blobUrl = base64ToBlobUrl(docsVisita.documento.split(",")[1], docsVisita.mime_type);
        Vue.set(context.state.visita.docs[pos], "documento", docsVisita.documento);
        Vue.set(context.state.visita.docs[pos], "thumb_url", blobUrl);
        Vue.set(context.state.visita.docs[pos], "doc_url", blobUrl);
      } else {
        context.state.output_doc = "thumb"
        await context.dispatch("buscarDocumento", param.id)
        context.state.output_doc = "url"
      }
      return
    },

    async sincronizarVisitas(context) {
      if (navigator.onLine) {
        const visitasDB = await getDataVT_DB(DB_VISITAS);

        for (const vdb of visitasDB.filter(v => v.criado_offline || v.atualizar)) {
          context.state.visita = vdb;

          if (vdb.criado_offline) {
            await context.dispatch("criarVisita");
          } else {
            context.state.visita.atualizar = false
            await context.dispatch("atualizarVisita");
          }
        }
      }
      context.state.id_visita = 0
    },

    async buscarVisitas(context) {
      context.state.visitas.carregando = true;
      context.state.visitas.itens = [];

      if (navigator.onLine) {
        await axios
          .get("/nutricao-animal/visita-tecnica/visitas", {
            params: {
              id: context.state.id_visita,
              ...context.state.filtros
            }
          })
          .then(async (res) => {
            if (res.data.success) {
              context.state.visitas.itens = res.data.data;
            } else Vue.toasted.error(res.data.msg);
          })
          .catch((e) => Vue.toasted.error(e))
      }

      var visitas_off_db = await getDataVT_DB(DB_VISITAS)
      visitas_off_db.filter((vis) => !navigator.onLine || (navigator.onLine && vis.criado_offline || navigator.onLine && vis.atualizar))
        .forEach(v => {
          v.permite_deletar = v.criado_offline;
          if (v.atualizar && navigator.onLine) {
            var pos = context.state.visitas.itens.findIndex((vOn) => vOn.id == v.id)
            context.state.visitas.itens[pos] = v
          } else {
            context.state.visitas.itens.push(v);
          }

        });

      context.state.visitas.carregando = false;
      context.state.id_visita = 0
    },
    async criarVisita(context) {
      try {
        if (navigator.onLine) {
          var res = await axios.post("/nutricao-animal/visita-tecnica/visitas", JSON.stringify(context.state.visita))
          if (res.status == 200 && res.data.success) {
            if (context.state.visita.criado_offline) {
              await deleteByKeyVT_DB(DB_VISITAS, context.state.visita.id)
            }
            context.state.visita.id = res.data.data.id
            context.state.id_visita = res.data.data.id
            context.state.id_sync = context.state.id_visita
            await context.dispatch("atualizarDocsDBOffline", res.data.data)
            await context.dispatch("atualizarVisitasCacheOffline")
            return true
          }

          Vue.toasted.error(res.data.msg, { position: "bottom-center" })
          return false
        } else {
          if (context.state.visitas.itens.findIndex((v) => v.matricula == context.state.visita.matricula &&
            v.data_visita == context.state.visita.data_visita && v.status.toUpperCase() != "CANCELADA") >= 0) {
            Vue.toasted.error("Já existe uma visita para este cooperado nesta data! (OFFLINE)", { position: "bottom-center" })
            return false
          }

          await createVT_DB(context.state.visita)

          return true
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" })
        return false
      }
    },
    async removerVisita(context, value) {
      try {
        if (navigator.onLine && !value.criado_offline) {
          var res = await axios.delete("/nutricao-animal/visita-tecnica/visitas", {
            params: {
              id: value.id
            }
          })
          if (res.status == 200 && res.data.success) {
            Vue.toasted.success(res.data.msg, { position: "bottom-center" })
            await deleteByKeyVT_DB(DB_VISITAS, value.id)
            return true
          }

          Vue.toasted.error(res.data.msg)
        } else {
          if (value.id == 0) {
            Vue.toasted.error("Sem conexão com a internet!")
          } else {

            try {
              var del = await deleteByKeyVT_DB(DB_VISITAS, value.id)
              if (del) {
                await context.dispatch("buscarVisitas")
              }
            } catch (error) {
              Vue.toasted.error(error)
            }

          }
        }
        return false
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" })
        return false
      }
    },
    async atualizarVisita(context) {

      context.state.atualizandoVisita = true
      try {

        var imgDel = []
        for (const key in context.state.visita.docs) {
          if (context.state.visita.docs[key].remover) {
            imgDel.push(context.state.visita.docs[key].id)
          }
        }

        imgDel.forEach((i) => {
          var pos = context.state.visita.docs.findIndex((d) => d.id == i)
          if (pos >= 0)
            context.state.visita.docs.splice(pos, 1)
        })

        if (navigator.onLine) {

          var res = await axios.put("/nutricao-animal/visita-tecnica/visitas", context.state.visita)
          if (res.status == 200 && res.data.success) {
            for (const idx of imgDel) {
              await deleteByKeyVT_DB(DB_DOCS, idx)
            }
            await context.dispatch("atualizarDocsDBOffline", res.data.data)
            await updateVT_DB(DB_VISITAS, context.state.visita.id, context.state.visita)
            //await updateVT_DB(DB_VISITAS, context.state.visita.id, context.state.visita)
            return true
          }

          Vue.toasted.error(res.data.msg, { position: "bottom-center" })
          return false
        } else {
          if (moment().isAfter(context.state.visita.data_hora_max_edicao)) {
            Vue.toasted.error("Edição bloqueada: o período de alterações desta visita encerrou.", { position: "bottom-center" });
          } else {
            context.state.visita.atualizar = true
            for (const doc of context.state.visita.docs.filter((d) => d.id == 0)) {
              doc.criado_offline = true
              doc.id = await updateVT_DB(DB_DOCS, 0, doc)
            }
            var ret = await updateVT_DB(DB_VISITAS, context.state.visita.id, context.state.visita)
            return ret
          }
        }
      } catch (error) {
        Vue.toasted.error(error, { position: "bottom-center" })
        return false
      } finally {
        context.state.atualizandoVisita = false
      }

    },

    async atualizarDocsDBOffline(context, data) {
      for (const doc of context.state.visita.docs) {
        if (doc.id == 0 || doc.criado_offline) {
          doc.id = data.docs.find((docOn) => docOn.doc_url == doc.doc_url).id
          doc.criado_offline = false
          await updateVT_DB(DB_DOCS, doc.id, doc)
        }
      }
    },

    async buscarDocumento({ state }, id) {
      if (!navigator.onLine) return;

      const isFile = state.output_doc && (state.output_doc.toLowerCase().includes('file'));

      try {
        const res = await axios.get("/nutricao-animal/visita-tecnica/documentos", {
          params: {
            id,
            output: state.output_doc
          },
          // se for arquivo, queremos um blob
          responseType: isFile ? 'blob' : 'json'
        });

        const pos = state.visita.docs.findIndex((v) => v.id == id);
        if (pos < 0) return;

        if (!isFile) {
          // CENÁRIO 1: API devolve JSON com { success, data: { url } }
          if (res.data && res.data.success && res.data.data && res.data.data.url) {
            Vue.set(state.visita.docs[pos], state.output_doc.toLowerCase() == "thumb" ? "thumb_url" : "doc_url", res.data.data.url);
          }
        } else {
          // CENÁRIO 2: API devolve um arquivo (octet-stream) -> transformar em blob URL
          const contentType = res.headers['content-type'] || 'application/octet-stream';

          const blob = new Blob([res.data], { type: contentType });

          // gera base64
          if (state.output_doc.toLowerCase().includes("sync")) {
            const base64 = await toBase64(blob);
            Vue.set(state.visita.docs[pos], "documento", base64);
            Vue.set(state.visita.docs[pos], "mime_type", contentType);
          }

          // guarda no estado pra usar no componente (ex: <a :href="doc.url" target="_blank">)          
          //Vue.set(state.visita.docs[pos], "url", blobUrl);

        }
      } catch (e) {
        console.log(`Houve um erro ao carregar o documento ${id}. error:${e}`);
      }
    },

    async baixarRelatorioPDF({ state }, { abrirEmNovaAba = true } = {}) {
      if (state.visita.criado_offline) {
        Vue.toasted.error("Esta visita ainda não foi enviada ao sistema. Sincronize os dados para gerar o relatório.")
        return
      }
      state.gerandoRelat = true
      try {
        if (navigator.onLine) {
          // pegue o id confiável
          const id = state.visita?.id || state.id_visita;
          if (!id) {
            Vue.toasted.error("Visita inválida.");
            state.gerandoRelat = false
            return;
          }

          const res = await axios.get("/nutricao-animal/visita-tecnica/visitas", {
            params: { id, output: "PDF" },
            responseType: "blob",
          });

          // se o backend mandou JSON de erro por engano
          const ct = (res.headers["content-type"] || "").toLowerCase();
          if (ct.includes("application/json")) {
            const text = await res.data.text?.() || "";
            try {
              const j = JSON.parse(text);
              Vue.toasted.error(j?.msg || "Erro ao gerar relatório.");
            } catch {
              Vue.toasted.error("Erro ao gerar relatório.");
            } finally {
              state.gerandoRelat = false
            }
            return;
          }

          const blob = new Blob([res.data], { type: "application/pdf" });

          // nome do arquivo (Content-Disposition)
          const dispo = res.headers["content-disposition"] || "";
          let fileName = `relatorio-visita-${id}.pdf`;
          const m = dispo.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
          if (m && m[1]) fileName = decodeURIComponent(m[1]);

          const url = URL.createObjectURL(blob);

          if (abrirEmNovaAba) {
            const win = window.open(url, "_blank");
            if (!win) forcarDownload(url, fileName);
          } else {
            forcarDownload(url, fileName);
          }

          setTimeout(() => URL.revokeObjectURL(url), 60 * 1000);
        } else {
          Vue.toasted.error("Sem conexão com a internet! Verifique sua rede e tente novamente.", {
            duration: 4000,
          });
        }
      } catch (error) {
        Vue.toasted.error(error?.message || "Não foi possível gerar o relatório.");
      } finally {
        state.gerandoRelat = false
      }

    },
    async sincronizarDados(context) {


      if (navigator.onLine) {
        context.state.produtores.msgSync = ""
        context.state.sincronizando = true
        context.state.produtores.msgSync = "Ajustando configurações..."
        await context.dispatch("buscarConfiguracoes")
        await saveObjectVT_DB(DB_CFG_VISITA, context.state.configuracoes.dados)

        context.state.produtores.modo = "sync"
        context.state.produtores.pesquisa = ""
        context.state.produtores.msgSync = "Buscando cooperados..."
        await context.dispatch("buscarProdutores")
        await saveArrayVT_DB(DB_PROD_VISITA, context.state.produtores.lista)
        context.state.produtores.modo = ""

        context.state.id_sync = 0
        context.state.produtores.msgSync = "Sincronizando visitas..."
        await context.dispatch("sincronizarVisitas")

        context.state.produtores.msgSync = "Atualizando visitas..."
        await context.dispatch("atualizarVisitasCacheOffline")

        context.state.produtores.msgSync = "Atualizando imagens..."
        await context.dispatch("atualizarImagensCacheOffline")

        context.state.produtores.msgSync = "Ajustando últimos detalhes..."
        await store.dispatch("sistema/getAtalhosIniciais");
        await saveAtalhosIniciais(store.state.sistema.atalhos);

        context.state.produtores.msgSync = "Salvando..."
        await saveObjectVT_DB(DB_SYNC, { data_ult_sinc: moment().format("DD/MM/YYYY"), usuario: store.state.usuario.usuarioLogado })

        context.state.sincronizando = false
        context.state.produtores.msgSync = ""

        await context.dispatch("buscarVisitas")

      } else {
        Vue.toasted.error("Sem conexão com a internet")
      }


    },
    async precisaSincronizar() {

      if (!isMobileMq()) return false;

      const dataSync = await getDataVT_DB(DB_SYNC)
      const hoje = moment().format("DD/MM/YYYY");

      // nunca sincronizou -> precisa
      if (dataSync.length == 0) return true;

      // se a data gravada for diferente de hoje -> precisa sincronizar
      return dataSync[0].data_ult_sinc !== hoje || dataSync[0].usuario.codigo !== store.state.usuario.usuarioLogado.codigo;
    },
    async abrirPreview(context, doc) {
      if (navigator.onLine) {
        context.state.output_doc = "url"        
        await context.dispatch("buscarDocumento", doc.id)        
        window.open(doc.doc_url, "_blank");
      } else
        if (doc.id > 0) {
          var docDB = await getDataByKeyVT_DB(DB_DOCS, doc.id);
          var blobUrl = base64ToBlobUrl(
            docDB.documento.split(",")[1],
            docDB.mime_type
          );
          window.open(blobUrl, "_blank");
        } else {
          window.open(doc.doc_url, "_blank");
        }
    },
  },
  getters: {}
};

export default visitaTecnicaStore;


function forcarDownload(objUrl, fileName) {
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = fileName;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}